type Props = {
  src: string;
  alt: string;
  onClose: () => void;
};

export const FullScreenImageModal = ({ src, alt, onClose }: Props) => {
  return (
    <div className="fixed z-50 inset-0 bg-black bg-opacity-50 flex items-center justify-center px-5" onClick={onClose}>
      <div className="bg-white h-10/12 rounded-2xl shadow-lg pb-5" onClick={(e) => e.stopPropagation()}>
        <div className="flex grow justify-end p-3">
          <button onClick={onClose} className="text-3xl">
            &times;
          </button>
        </div>
        <div className="flex grow justify-center items-center">
          <img className="w-1/2 h-1/2 object-scale-down" src={src} alt={alt} />
        </div>
      </div>
    </div>
  );
};
